
import { computed, onMounted, ref } from 'vue';
import { NodeType } from '@amplify/amp-module';
import NodeWrapper from '@/components/graph/common/NodeWrapper';
import RichTextEditor from '@/components/rte/RichTextEditor';
import { useNodeUtils } from '@/composables/useNodeUtils';
import { getInnerText } from '@/utils';

export default {
  components: { RichTextEditor, NodeWrapper },

  setup() {
    const nodeType = NodeType.message;
    const nodeActions = [{ click: true, key: 'bottom' }];

    const { ampData, uiData, nodeId, nodeRef, canEditAmp, updateDelay } = useNodeUtils({ nodeType });

    const htmlEditor = ref(null);

    const isDone = computed(() => getInnerText(ampData.value.html).length > 0);

    onMounted(() => {
      if (uiData.value.selected) {
        htmlEditor.value?.onEditorClick();
      }
    });

    const onEditorChange = ({ html }) => {
      if (!canEditAmp.value) {
        return;
      }

      ampData.value = { ...ampData.value, html };
    };

    return {
      ampData,
      canEditAmp,
      htmlEditor,
      isDone,
      nodeActions,
      nodeId,
      nodeRef,
      nodeType,
      uiData,
      onEditorChange,
      updateDelay,
    };
  },
};
